"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6436],{

/***/ 61146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ HeaderTopBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/index.js + 1 modules
var TopBar = __webpack_require__(88311);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/Logo.js
var Logo = __webpack_require__(39755);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/Dropdown.js
var Dropdown = __webpack_require__(43223);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/Nav.js
var Nav = __webpack_require__(65717);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 12 modules
var i18 = __webpack_require__(36971);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/index.js + 1 modules
var MegaMenu = __webpack_require__(69514);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/Grid.js
var Grid = __webpack_require__(15062);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/Item.js
var Item = __webpack_require__(4991);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/ButtonTheme/index.js + 1 modules
var ButtonTheme = __webpack_require__(10980);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 2 modules
var Icon = __webpack_require__(19911);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
;// CONCATENATED MODULE: ./src/HeaderTopBar/PlatformDropDown.js











const platformImg = "/images/dotmatics/lab-archives/top-bar/platform.png";
const PlatformDropDown = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("header");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu/* default */.Z, {
                utility: {
                    justify: "start"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                    md: 8,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                sx: {
                                    fontSize: "l",
                                    fontColor: "white",
                                    fontWeight: "bold"
                                },
                                children: t("TOPBAR.platform.TITLE")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                sx: {
                                    fontSize: "s",
                                    fontColor: "white"
                                },
                                children: t("TOPBAR.platform.DESC")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTheme/* default.Link */.Z.Link, {
                                href: routes/* default.external.platform */.Z.external.platform,
                                spacing: {
                                    px: 5,
                                    py: 3,
                                    mt: 4
                                },
                                styleType: "topbar",
                                children: [
                                    t("TOPBAR.platform.BTN"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        spacing: {
                                            ml: 4
                                        },
                                        name: "link-ext"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: platformImg,
                className: "position-absolute top-0 right-0"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/MegaMenuBlockLink.js
var MegaMenuBlockLink = __webpack_require__(80178);
;// CONCATENATED MODULE: ./src/HeaderTopBar/ProductsTopBar.js









const prismLogo = "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-Prism.svg";
const geneiousLogo = "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-Geneious.svg";
const snapgeneLogo = "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-SnapGene.svg";
const labArchivesLogo = "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-LabArchives.svg";
const proteinMetricLogo = "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-Protein-Metrics.svg";
const omiqLogo = "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-OMIQ.svg";
const fcsExpressLogo = "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-FCS-Express.svg";
const nQueryLogo = "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-nQuery.svg";
const ProductsTopBar = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("header");
    const utmSiteName = "geneious";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenu/* default */.Z, {
        spacing: {
            py: 5
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.products.UTM_LINK", {
                        mainLink: routes/* default.external.products.prism */.Z.external.products.prism,
                        utmSiteName
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: prismLogo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.products.PRISM")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: "#",
                    onClick: (e)=>e.preventDefault(),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: geneiousLogo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.products.GENEIOUS")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.products.UTM_LINK", {
                        mainLink: routes/* default.external.products.snapgene */.Z.external.products.snapgene,
                        utmSiteName
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: snapgeneLogo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.products.SNAPGENE")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.products.UTM_LINK", {
                        mainLink: routes/* default.external.products.labArchives */.Z.external.products.labArchives,
                        utmSiteName
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: labArchivesLogo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.products.LABARCHIVES")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.products.UTM_LINK", {
                        mainLink: routes/* default.external.products.proteinMetrics */.Z.external.products.proteinMetrics,
                        utmSiteName
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: proteinMetricLogo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.products.PROTEINMETRIC")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.products.UTM_LINK", {
                        mainLink: routes/* default.external.products.omiq */.Z.external.products.omiq,
                        utmSiteName
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: omiqLogo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.products.OMIQ")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.products.UTM_LINK", {
                        mainLink: routes/* default.external.products.fcsExpress */.Z.external.products.fcsExpress,
                        utmSiteName
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: fcsExpressLogo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.products.FCSEXPRESS")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.products.UTM_LINK", {
                        mainLink: routes/* default.external.products.nQuery */.Z.external.products.nQuery,
                        utmSiteName
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                            src: nQueryLogo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.products.NQUERY")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                sm: 12,
                md: 12,
                lg: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTheme/* default.Link */.Z.Link, {
                    href: routes/* default.external.portfolio */.Z.external.portfolio,
                    spacing: {
                        px: 5,
                        py: 3,
                        mt: 4,
                        mb: 8
                    },
                    styleType: "topbar",
                    children: [
                        t("TOPBAR.products.BTN"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            spacing: {
                                ml: 4
                            },
                            name: "link-ext"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/HeaderTopBar/index.js











const logoImg = "/images/common/dotmatics-logo-white.svg";
const HeaderTopBar = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("header");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopBar/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: logoImg
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.ZP, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                    isMegaMenu: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Title */.Z.Title, {
                            triangle: true,
                            triangleProps: {
                                color: "dotmatics-2",
                                isOpenColor: "dotmatics-2"
                            },
                            children: t("TOPBAR.PLATFORM_PRODUCTS")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Body */.Z.Body, {
                            utility: {
                                bgColor: "dotmatics-6",
                                border: {
                                    top: {
                                        width: 1,
                                        color: "white--20"
                                    },
                                    bottom: {
                                        width: 1,
                                        color: "white--20"
                                    }
                                }
                            },
                            spacing: {
                                my: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformDropDown, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsTopBar, {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 65651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports logoPath, logoAlt */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_LogoLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46096);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30233);




const logoPath = "/images/geneious/logo/logo-geneious.svg";
const logoAlt = "Geneious by Dotmatics";
const prerenderedLogo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LogoLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    href: _routes__WEBPACK_IMPORTED_MODULE_3__/* ["default"].external.indexPhp */ .Z.external.indexPhp,
    imgSrc: logoPath,
    alt: logoAlt,
    "data-qa-selector": "header-logo"
});
/* harmony default export */ __webpack_exports__["ZP"] = (prerenderedLogo);


/***/ }),

/***/ 49478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ SiteFooterFeature; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9458);
/* harmony import */ var _insightfulscience_atomic_react_Footer_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38661);
/* harmony import */ var _insightfulscience_atomic_react_Footer_Main__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78682);
/* harmony import */ var _insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53512);
/* harmony import */ var _insightfulscience_atomic_react_Footer_Sidebar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58287);
/* harmony import */ var _insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7212);
/* harmony import */ var _insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31987);
/* harmony import */ var _insightfulscience_atomic_react_Footer_Logo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33768);
/* harmony import */ var _insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36971);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10334);
/* harmony import */ var _insightfulscience_atomic_react_Footer_Social__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72025);
/* harmony import */ var _insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6949);
/* harmony import */ var _insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(73972);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(30233);

















const iconPrime = "/images/geneious/logo/icon-prime.svg";
const iconBiologics = "/images/geneious/logo/icon-biologics.svg";
const logoImg = "/images/geneious/logo/logo-geneious-dotmatics.svg";
const SiteFooter = (param)=>{
    let { className =""  } = param;
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_10__/* .useLocale */ .bU)("footer");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Main__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavRow */ .z4, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                    sm: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListTitle */ .Q1, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavTitleLink */ .px, {
                                                weight: "bold",
                                                href: "https://www.geneious.com/features/",
                                                utility: {
                                                    display: "flex"
                                                },
                                                children: [
                                                    t("GENEIOUS_PRIME"),
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        src: iconPrime,
                                                        spacing: {
                                                            ml: 2
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavRow */ .z4, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavList */ .Hr, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/",
                                                                    isBold: true,
                                                                    children: t("FEATURES")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/sanger-sequence-analysis/",
                                                                    children: t("SANGER_SEQUENCING")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/ngs-visualization-downstream-analysis/",
                                                                    children: t("NGS_SEQUENCING")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/assembly-mapping/",
                                                                    children: t("ASSWMBLY_AND_MAPPING")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/sequence-alignment/",
                                                                    children: t("ALIGNMENTS")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/phylogenetic-tree-building/",
                                                                    children: t("PHYLOHENETICS")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/molecular-cloning/",
                                                                    children: t("MOLECULAR_CLONING")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/primer-design/",
                                                                    children: t("PRIMER_DESIGN")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/crispr/",
                                                                    children: t("CRISPR")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/sequence-analysis-annotation-prediction/",
                                                                    children: t("ANNOTATE_AND_PREDICT")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/microsatellite-genotyping/",
                                                                    children: t("MICROSATELLITE_ANALYSIS")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/searching-blast-genbank/",
                                                                    children: t("NCBI_Blast")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/workflows/",
                                                                    children: t("WORKFLOWS")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/features/import-export-sequence-data/",
                                                                    children: t("CONVERT_FORMATS")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.cloud */ .Z.external.cloud,
                                                                    children: t("CLOUD")
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavList */ .Hr, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/resources/",
                                                                    isBold: true,
                                                                    children: t("RESOURCES")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://manage.geneious.com/free-trial",
                                                                    children: t("FREE_TRIAL")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/pricing/",
                                                                    children: t("PRICING")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/quote/",
                                                                    children: t("QUOTE_REQUEST")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/download/",
                                                                    children: t("DOWNLOAD")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/plugins/",
                                                                    children: t("PLUGINS")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/api-developers/",
                                                                    children: t("API_CLI")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/academy/",
                                                                    children: t("ACADEMY")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/manual/",
                                                                    children: t("USER_MANUAL")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/free-course-license/",
                                                                    children: t("COURSE_LICENSES")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/igem/",
                                                                    children: t("IGEM")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/whats-new/",
                                                                    children: t("WHATS_NEW")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://help.geneious.com/hc/en-us",
                                                                    children: t("SUPPORT")
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                    sm: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListTitle */ .Q1, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavTitleLink */ .px, {
                                                weight: "bold",
                                                href: "https://www.geneious.com/biopharma/",
                                                utility: {
                                                    display: "flex"
                                                },
                                                children: [
                                                    t("GENEIOUS_BIOLOGICS"),
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        src: iconBiologics,
                                                        spacing: {
                                                            ml: 2
                                                        }
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavRow */ .z4, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavList */ .Hr, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/",
                                                                    isBold: true,
                                                                    children: t("FEATURES")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/",
                                                                    children: t("ANTIBODY_DISCOVERY")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/",
                                                                    children: t("CANDIDATE_SELECTION")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/features/clustering-filtering/",
                                                                    children: t("CLUSTERING_FILTERING")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/features/antibody-ngs-data-analysis/",
                                                                    children: t("NGS_SCREENING")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/features/data-security/",
                                                                    children: t("DATA_SECURITY")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/antibody-sequence-analysis/",
                                                                    children: t("FREE_ANTIBODY_ANNOTATOR")
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavList */ .Hr, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/resources/",
                                                                    isBold: true,
                                                                    children: t("RESOURCES")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/get-started-free/",
                                                                    children: t("FREE_TRIAL")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/plans/",
                                                                    children: t("PRICING")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/request-demo/",
                                                                    children: t("REQUEST_DEMO")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/academy/#antibody-discovery",
                                                                    children: t("ACADEMY")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://help.geneiousbiologics.com/hc/en-us/categories/360003073291",
                                                                    children: t("USER_GUIDE")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://help.geneiousbiologics.com/",
                                                                    children: t("SUPPORT")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                                    href: "https://www.geneious.com/biopharma/contact-us/",
                                                                    children: t("CONTACT_SALES")
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                    sm: "auto",
                                    lg: "shrink",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListTitle */ .Q1, {
                                            children: t("COMPANY")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavList */ .Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "https://www.geneious.com/about/",
                                                        children: t("ABOUT_GENEIOUS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "https://www.geneious.com/resources/customers/",
                                                        children: t("CUSTOMERS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "https://www.geneious.com/resources/citations/",
                                                        children: t("CITATIONS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "https://www.dotmatics.com/",
                                                        children: t("DOTMATICS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "https://www.dotmatics.com/portfolio",
                                                        children: t("PORTFOLIO")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "https://www.dotmatics.com/about-careers",
                                                        children: t("CAREERS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.security */ .Z.external.security,
                                                        children: t("SECURITY")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "https://www.geneious.com/contact-us/",
                                                        children: t("CONTACT")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Sidebar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Logo__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                logoPath: logoImg,
                                logoAlt: "",
                                href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.indexPhp */ .Z.external.indexPhp
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* .FooterCopyrightText */ .rQ, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* .FooterCopyrightText.CompanyName */ .rQ.CompanyName, {
                                        children: [
                                            "\xa9 ",
                                            new Date().getFullYear(),
                                            " ",
                                            t("DOTMATICS")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* .FooterCopyrightLink */ .X6, {
                                        href: "https://www.geneious.com/privacy-policy/",
                                        spacing: {
                                            mb: 2
                                        },
                                        children: t("PRIVACY")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* .FooterCopyrightLink */ .X6, {
                                        href: "https://www.geneious.com/legal/",
                                        spacing: {
                                            mb: 2
                                        },
                                        children: t("LEGAL")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* .FooterCopyrightLink */ .X6, {
                                        href: "https://donotsell.dotmatics.com/hc/en-us/requests/new ",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                            children: t("DO_NOT_SHELL")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Social__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Social__WEBPACK_IMPORTED_MODULE_12__/* .FooterSocialItemLink */ .F, {
                                        href: "https://www.twitter.com/geneious",
                                        name: "twitter-square"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Social__WEBPACK_IMPORTED_MODULE_12__/* .FooterSocialItemLink */ .F, {
                                        href: "https://www.youtube.com/c/geneious",
                                        name: "youtube-square"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Social__WEBPACK_IMPORTED_MODULE_12__/* .FooterSocialItemLink */ .F, {
                                        href: "https://www.linkedin.com/company/geneious",
                                        name: "linkedin-square"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
SiteFooter.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_16__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (SiteFooter);
const SiteFooterFeature = ()=>{
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_10__/* .useLocale */ .bU)("footer");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "bg-color-6",
        isBorderNone: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            utility: {
                border: {
                    top: {
                        width: 1,
                        color: "white--15"
                    }
                }
            },
            spacing: {
                pt: 6
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Main__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    md: 12,
                    lg: 10,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavRow */ .z4, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                    sm: 6,
                                    md: 3,
                                    lg: 3,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListTitle */ .Q1, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavTitleLink */ .px, {
                                                weight: "bold",
                                                children: t("PRODUCTS")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavList */ .Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.features */ .Z.external.features,
                                                        children: [
                                                            t("GENEIOUS_PRIME"),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                                sx: {
                                                                    fontSize: "xs",
                                                                    fontColor: "black--15"
                                                                },
                                                                utility: {
                                                                    display: "block"
                                                                },
                                                                children: t("GENEIOUS_PRIME_DESCRIPTION")
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.biopharma */ .Z.external.biopharma,
                                                        children: [
                                                            t("GENEIOUS_BIOLOGICS"),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                                sx: {
                                                                    fontSize: "xs",
                                                                    fontColor: "black--15"
                                                                },
                                                                utility: {
                                                                    display: "block"
                                                                },
                                                                children: t("GENEIOUS_BIOLOGICS_DESCRIPTION")
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                    sm: 6,
                                    lg: 2,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListTitle */ .Q1, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavTitleLink */ .px, {
                                                weight: "bold",
                                                href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.features */ .Z.external.features,
                                                children: t("GENEIOUS_PRIME")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavList */ .Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.features */ .Z.external.features,
                                                        children: t("ALL_FEATURES")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "".concat(_routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.features */ .Z.external.features, "/sanger-sequence-analysis/"),
                                                        children: t("SANGER_SEQUENCING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "".concat(_routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.features */ .Z.external.features, "/ngs-visualization-downstream-analysis/"),
                                                        children: t("NGS_SEQUENCING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "".concat(_routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.features */ .Z.external.features, "/assembly-mapping/"),
                                                        children: t("ASSWMBLY_AND_MAPPING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "".concat(_routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.features */ .Z.external.features, "/molecular-cloning/"),
                                                        children: t("MOLECULAR_CLONING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "".concat(_routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.features */ .Z.external.features, "/phylogenetic-tree-building/"),
                                                        children: t("PHYLOHENETICS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.crispr */ .Z.external.crispr,
                                                        children: t("CRISPR")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.whatsNew */ .Z.external.whatsNew,
                                                        children: t("WHATS_NEW")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                    sm: 6,
                                    lg: 2,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListTitle */ .Q1, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavTitleLink */ .px, {
                                                weight: "bold",
                                                href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.resources */ .Z.external.resources,
                                                children: t("RESOURCES")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavList */ .Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.tutorials */ .Z.external.tutorials,
                                                        children: t("PRODUCT_TUTORIAL")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.manual */ .Z.external.manual,
                                                        children: t("MANUAL")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.download */ .Z.external.download,
                                                        children: t("DOWNLOAD")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.plugins */ .Z.external.plugins,
                                                        children: t("PLUGINS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.coronavirus */ .Z.external.coronavirus,
                                                        children: t("CORONAVIRUS_RESOURCES")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: "".concat(_routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.features */ .Z.external.features, "/import-export-sequence-data/"),
                                                        children: t("IMPORT_COMMON_FILE_TYPES")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.help */ .Z.external.help,
                                                        children: t("SUPPORT")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                    sm: 6,
                                    lg: 2,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListTitle */ .Q1, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavTitleLink */ .px, {
                                                weight: "bold",
                                                href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.howToBuy */ .Z.external.howToBuy,
                                                children: t("BUY_GENEIOUS")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavList */ .Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.freeTrialExternal */ .Z.external.freeTrialExternal,
                                                        children: t("FREE_TRIAL")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.howToBuy */ .Z.external.howToBuy,
                                                        children: t("PRICING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.quote */ .Z.external.quote,
                                                        children: t("QUOTE_REQUEST")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.courseLicenses */ .Z.external.courseLicenses,
                                                        children: t("COURSE_LICENSES")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.igem */ .Z.external.igem,
                                                        children: t("IGEM")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                    sm: 6,
                                    lg: 3,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListTitle */ .Q1, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavTitleLink */ .px, {
                                                weight: "bold",
                                                href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.about */ .Z.external.about,
                                                children: t("COMPANY")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavList */ .Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.about */ .Z.external.about,
                                                        children: t("ABOUT")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.dotmatics */ .Z.external.dotmatics,
                                                        children: t("DOTMATICS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.portfolio */ .Z.external.portfolio,
                                                        children: t("PORTFOLIO")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.careersExternal */ .Z.external.careersExternal,
                                                        children: t("CAREERS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.customers */ .Z.external.customers,
                                                        children: t("CUSTOMERS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.citations */ .Z.external.citations,
                                                        children: t("CITATIONS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavListItem */ .iT, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavItemLink */ .jO, {
                                                        href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.contactUs */ .Z.external.contactUs,
                                                        children: t("CONTACT")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Sidebar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    lg: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        className: "mt-8--sm",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavRow */ .z4, {
                            center: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Nav__WEBPACK_IMPORTED_MODULE_5__/* .FooterNavCol */ .Pw, {
                                sm: 12,
                                md: 5,
                                lg: 12,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Logo__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            logoPath: "/images/geneious/logo/logo-geneious-white.svg",
                                            logoAlt: "logoAlt.geneious"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* .FooterCopyrightText */ .rQ, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* .FooterCopyrightText.CompanyName */ .rQ.CompanyName, {
                                                    children: [
                                                        "\xa9 ",
                                                        new Date().getFullYear(),
                                                        " Dotmatics"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* .FooterCopyrightLink */ .X6, {
                                                    href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.privacyPolicy */ .Z.external.privacyPolicy,
                                                    className: "display-block mb-2",
                                                    children: t("PRIVACY")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* .FooterCopyrightLink */ .X6, {
                                                    href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.termsOfService */ .Z.external.termsOfService,
                                                    className: "display-block mb-2",
                                                    children: t("LEGAL")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Footer_Copyright__WEBPACK_IMPORTED_MODULE_7__/* .FooterCopyrightLink */ .X6, {
                                                    href: _routes__WEBPACK_IMPORTED_MODULE_15__/* ["default"].external.doNotSell */ .Z.external.doNotSell,
                                                    className: "display-flex justify-content-center mb-2",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "max-w-50--sm",
                                                        children: t("DO_NOT_SHELL")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 41069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69514);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15062);
/* harmony import */ var _insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6949);
/* harmony import */ var _insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10334);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4991);
/* harmony import */ var _insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36971);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25522);









const iconPrime = "/images/geneious/logo/icon-prime.svg";
const iconBiologics = "/images/geneious/logo/icon-biologics.svg";
/* harmony default export */ __webpack_exports__["Z"] = (()=>{
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_7__/* .useLocale */ .bU)("header");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_MegaMenu__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_MegaMenu_Grid__WEBPACK_IMPORTED_MODULE_3__/* .MegaMenuCol */ .p, {
                md: 12,
                lg: 5,
                utility: {
                    lg: {
                        border: {
                            right: {
                                width: 1,
                                color: "black--20"
                            }
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        utility: {
                            display: "flex",
                            align: {
                                items: "center"
                            }
                        },
                        sx: {
                            fontSize: "xl",
                            fontWeight: "semi"
                        },
                        spacing: {
                            pl: 1
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            color: "black",
                            hoverColor: "3",
                            href: "https://www.geneious.com/features/",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: iconPrime,
                                    spacing: {
                                        mr: 2
                                    }
                                }),
                                " ",
                                t("PRODUCTS_LIST.PRIME_TITLE")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        sx: {
                            fontSize: "m",
                            fontColor: "black--46"
                        },
                        spacing: {
                            my: 2,
                            pl: 1
                        },
                        children: t("PRODUCTS_LIST.PRIME_DESCR")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/features/#sequence-analysis",
                                    children: t("PRODUCTS_LIST.PRIME_SEQUENCE")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/features/#molecular-biology",
                                    children: t("PRODUCTS_LIST.PRIME_CLONING")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/features/#automation",
                                    children: t("PRODUCTS_LIST.PRIME_AUTOMATION")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/features/",
                                    children: t("PRODUCTS_LIST.PRIME_EXPLORE")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_MegaMenu_Grid__WEBPACK_IMPORTED_MODULE_3__/* .MegaMenuCol */ .p, {
                md: 12,
                lg: 5,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        utility: {
                            display: "flex",
                            align: {
                                items: "center"
                            }
                        },
                        sx: {
                            fontSize: "xl",
                            fontWeight: "semi"
                        },
                        spacing: {
                            pl: 1
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            color: "black",
                            hoverColor: "3",
                            href: "https://www.geneious.com/biopharma/",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: iconBiologics,
                                    spacing: {
                                        mr: 2
                                    }
                                }),
                                " ",
                                t("PRODUCTS_LIST.BIOLOGICS_TITLE")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        sx: {
                            fontSize: "m",
                            fontColor: "black--46"
                        },
                        spacing: {
                            my: 2,
                            pl: 1
                        },
                        children: t("PRODUCTS_LIST.BIOLOGICS_DESCR")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/biopharma/",
                                    children: t("PRODUCTS_LIST.BIOLOGICS_DISCOVERY")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/biopharma/#antibody-discovery",
                                    children: t("PRODUCTS_LIST.BIOLOGICS_CANDIDATE")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/biopharma/#collaboration-security",
                                    children: t("PRODUCTS_LIST.BIOLOGICS_SECURITY")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/biopharma/",
                                    children: t("PRODUCTS_LIST.BIOLOGICS_EXPLORE")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});


/***/ }),

/***/ 81412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69514);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15062);
/* harmony import */ var _insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6949);
/* harmony import */ var _insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10334);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4991);
/* harmony import */ var _insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36971);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25522);









const iconPrime = "/images/geneious/logo/icon-prime.svg";
const iconBiologics = "/images/geneious/logo/icon-biologics.svg";
/* harmony default export */ __webpack_exports__["Z"] = (()=>{
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_7__/* .useLocale */ .bU)("header");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_MegaMenu__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_MegaMenu_Grid__WEBPACK_IMPORTED_MODULE_3__/* .MegaMenuCol */ .p, {
                md: 12,
                lg: 5,
                utility: {
                    lg: {
                        border: {
                            right: {
                                width: 1,
                                color: "black--20"
                            }
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        utility: {
                            display: "flex",
                            align: {
                                items: "center"
                            }
                        },
                        sx: {
                            fontSize: "xl",
                            fontWeight: "semi"
                        },
                        spacing: {
                            pl: 1
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            color: "black",
                            hoverColor: "3",
                            href: "https://www.geneious.com/resources/",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: iconPrime,
                                    spacing: {
                                        mr: 2,
                                        pl: 1
                                    }
                                }),
                                " ",
                                t("RESOURCES_LIST.PRIME_TITLE")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/academy/getting-started/",
                                    children: t("RESOURCES_LIST.PRIME_STARTED")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/academy/",
                                    children: t("RESOURCES_LIST.PRIME_ACADEMY")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/manual/",
                                    children: t("RESOURCES_LIST.PRIME_MANUAL")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://help.geneious.com/hc/en-us/categories/360003482792",
                                    children: t("RESOURCES_LIST.PRIME_KNOWLEDGE")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/download/",
                                    children: t("RESOURCES_LIST.PRIME_DOWNLOAD")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/plugins/",
                                    children: t("RESOURCES_LIST.PRIME_PLUGINS")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_MegaMenu_Grid__WEBPACK_IMPORTED_MODULE_3__/* .MegaMenuCol */ .p, {
                md: 12,
                lg: 5,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        utility: {
                            display: "flex",
                            align: {
                                items: "center"
                            }
                        },
                        sx: {
                            fontSize: "xl",
                            fontWeight: "semi"
                        },
                        spacing: {
                            pl: 1
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            color: "black",
                            hoverColor: "3",
                            href: "https://help.geneiousbiologics.com/hc/en-us",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: iconBiologics,
                                    spacing: {
                                        mr: 2,
                                        pl: 1
                                    }
                                }),
                                t("RESOURCES_LIST.BIOLOGICS_TITLE")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://help.geneiousbiologics.com/hc/en-us/articles/360045069411",
                                    children: t("RESOURCES_LIST.BIOLOGICS_STARTED")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/academy/#antibody-discovery",
                                    children: t("RESOURCES_LIST.BIOLOGICS_ACADEMY")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://help.geneiousbiologics.com/hc/en-us/categories/360003073291",
                                    children: t("RESOURCES_LIST.BIOLOGICS_GUIDE")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/biopharma/features/data-security/",
                                    children: t("RESOURCES_LIST.BIOLOGICS_SECURITY")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://www.geneious.com/biopharma/request-demo/",
                                    children: t("RESOURCES_LIST.BIOLOGICS_DEMO")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});


/***/ }),

/***/ 25329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69514);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15062);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40535);
/* harmony import */ var _insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6949);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4991);
/* harmony import */ var _insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31987);
/* harmony import */ var _insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10334);
/* harmony import */ var _insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36971);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30233);











const iconPrime = "/images/geneious/logo/icon-prime.svg";
const iconBiologics = "/images/geneious/logo/icon-biologics.svg";
/* harmony default export */ __webpack_exports__["Z"] = (()=>{
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_9__/* .useLocale */ .bU)("header");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        utility: {
            justify: "end"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_MegaMenu_Grid__WEBPACK_IMPORTED_MODULE_3__/* .MegaMenuCol */ .p, {
            md: 12,
            lg: "shrink",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Title__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: "SIGN IN"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            spacing: {
                                lg: {
                                    my: 4
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                href: _routes__WEBPACK_IMPORTED_MODULE_10__/* ["default"].myAccount */ .Z.myAccount,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    utility: {
                                        display: "flex",
                                        align: {
                                            items: "center"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            src: iconPrime,
                                            spacing: {
                                                mr: 2
                                            }
                                        }),
                                        t("SIGNIN_LIST.PRIME")
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            spacing: {
                                lg: {
                                    my: 4
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                href: "https://biologics.geneious.com/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    utility: {
                                        display: "flex",
                                        align: {
                                            items: "center"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            src: iconBiologics,
                                            spacing: {
                                                mr: 2
                                            }
                                        }),
                                        t("SIGNIN_LIST.BIOLOGICS")
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            spacing: {
                                lg: {
                                    my: 4
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                href: "https://annotator.geneious.com/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Inline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    utility: {
                                        display: "flex",
                                        align: {
                                            items: "center"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            src: iconBiologics,
                                            spacing: {
                                                mr: 2
                                            }
                                        }),
                                        t("SIGNIN_LIST.BIOLOGICS_STARTER")
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
});


/***/ }),

/***/ 20802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69514);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15062);
/* harmony import */ var _insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6949);
/* harmony import */ var _insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10334);
/* harmony import */ var _insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4991);
/* harmony import */ var _insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36971);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25522);









const iconPrime = "/images/geneious/logo/icon-prime.svg";
const iconBiologics = "/images/geneious/logo/icon-biologics.svg";
/* harmony default export */ __webpack_exports__["Z"] = (()=>{
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_7__/* .useLocale */ .bU)("header");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_MegaMenu__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_MegaMenu_Grid__WEBPACK_IMPORTED_MODULE_3__/* .MegaMenuCol */ .p, {
                md: 12,
                lg: 5,
                utility: {
                    lg: {
                        border: {
                            right: {
                                width: 1,
                                color: "black--20"
                            }
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        utility: {
                            display: "flex",
                            align: {
                                items: "center"
                            }
                        },
                        sx: {
                            fontSize: "xl",
                            fontWeight: "semi"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            color: "black",
                            hoverColor: "3",
                            href: "https://help.geneious.com/",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: iconPrime,
                                    spacing: {
                                        mr: 2
                                    }
                                }),
                                " ",
                                t("SUPPORT_LIST.PRIME_TITLE")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://help.geneious.com/",
                                    children: t("SUPPORT_LIST.PRIME_HELP_CENTER")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://help.geneious.com/hc/en-us/requests/new",
                                    children: t("SUPPORT_LIST.PRIME_CONTACT")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_MegaMenu_Grid__WEBPACK_IMPORTED_MODULE_3__/* .MegaMenuCol */ .p, {
                md: 12,
                lg: 5,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        utility: {
                            display: "flex",
                            align: {
                                items: "center"
                            }
                        },
                        sx: {
                            fontSize: "xl",
                            fontWeight: "semi"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            color: "black",
                            hoverColor: "3",
                            href: "https://help.geneiousbiologics.com/",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: iconBiologics,
                                    spacing: {
                                        mr: 2
                                    }
                                }),
                                " ",
                                t("SUPPORT_LIST.BIOLOGICS_TITLE")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://help.geneiousbiologics.com/",
                                    children: t("SUPPORT_LIST.BIOLOGICS_HELP_CENTER")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                spacing: {
                                    lg: {
                                        my: 4
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_MegaMenu_Item__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Link */ .Z.Link, {
                                    href: "https://help.geneiousbiologics.com/hc/en-us/requests/new",
                                    children: t("SUPPORT_LIST.BIOLOGICS_CONTACT")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});


/***/ }),

/***/ 5255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ SiteHeaderFeature; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38529);
/* harmony import */ var _insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18774);
/* harmony import */ var _insightfulscience_atomic_react_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19911);
/* harmony import */ var _insightfulscience_smart_react_NextLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5098);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36971);
/* harmony import */ var _insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67478);
/* harmony import */ var _insightfulscience_atomic_react_Navbar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37762);
/* harmony import */ var _insightfulscience_atomic_react_NavbarDropdown__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86210);
/* harmony import */ var _insightfulscience_atomic_react_NavbarDropdown_Title__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36555);
/* harmony import */ var _insightfulscience_atomic_react_NavbarDropdown_Menu__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1385);
/* harmony import */ var _insightfulscience_atomic_react_Navbar_Item__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88881);
/* harmony import */ var _insightfulscience_atomic_react_Navbar_Link__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81453);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(30233);
/* harmony import */ var _PrerenderedLogo__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65651);
/* harmony import */ var _ProductsDropdown__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41069);
/* harmony import */ var _ResourcesDropdown__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(81412);
/* harmony import */ var _SupportDropdown__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(20802);
/* harmony import */ var _SignInDropdown__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(25329);
/* harmony import */ var _HeaderTopBar__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(61146);






















const SiteHeader = (param)=>{
    let { isAuthorized , showTopBar =true , ...props } = param;
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_6__/* .useLocale */ .bU)("header");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            showTopBar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeaderTopBar__WEBPACK_IMPORTED_MODULE_20__/* .HeaderTopBar */ .r, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                logo: _PrerenderedLogo__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP,
                isBorderBottomNone: true,
                ...props,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X2, {
                    sizing: {
                        w: "full"
                    },
                    middle: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .JX, {
                            lg: "auto",
                            utility: {
                                justify: "center"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Navbar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                nav: "primary",
                                type: 1,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_NavbarDropdown__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        isMegaMenu: true,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_NavbarDropdown_Title__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                children: t("PRODUCTS")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_NavbarDropdown_Menu__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                isList: false,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductsDropdown__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_NavbarDropdown__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        isMegaMenu: true,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_NavbarDropdown_Title__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                children: t("RESOURCES")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_NavbarDropdown_Menu__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                isList: false,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ResourcesDropdown__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_NavbarDropdown__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        isMegaMenu: true,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_NavbarDropdown_Title__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                children: t("SUPPORT")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_NavbarDropdown_Menu__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                isList: false,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SupportDropdown__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Item__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Navbar_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            href: "https://www.geneious.com/pricing/",
                                            children: [
                                                " ",
                                                t("HOW_TO_BUY")
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .JX, {
                            lg: "shrink",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Navbar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                nav: "secondary",
                                type: 1,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_NavbarDropdown__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        isSecondaryNav: true,
                                        isMegaMenu: true,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_NavbarDropdown_Title__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                children: t("SIGNIN")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_NavbarDropdown_Menu__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                isList: false,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SignInDropdown__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Item__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        secondary: true,
                                        className: "secondary-nav__item-trial",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Link */ .Z.Link, {
                                            href: _routes__WEBPACK_IMPORTED_MODULE_14__/* ["default"].freeTrial */ .Z.freeTrial,
                                            size: "s",
                                            children: t("FREE_TRIAL")
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
SiteHeader.propTypes = {
    isAuthorized: prop_types__WEBPACK_IMPORTED_MODULE_21__.bool.isRequired,
    showTopBar: prop_types__WEBPACK_IMPORTED_MODULE_21__.bool
};
/* harmony default export */ __webpack_exports__["Z"] = (SiteHeader);
const SiteHeaderFeature = (param)=>{
    let { isAuthorized =false , ...props } = param;
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_6__/* .useLocale */ .bU)("header");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        logo: _PrerenderedLogo__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP,
        className: "bg--transparent",
        isBorderBottomNone: true,
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Navbar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                nav: "primary",
                type: 1,
                inverted: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Item__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            href: _routes__WEBPACK_IMPORTED_MODULE_14__/* ["default"].external.features */ .Z.external.features,
                            children: t("FEATURES")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Item__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            href: _routes__WEBPACK_IMPORTED_MODULE_14__/* ["default"].external.resources */ .Z.external.resources,
                            children: t("RESOURCES")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Item__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            href: _routes__WEBPACK_IMPORTED_MODULE_14__/* ["default"].external.help */ .Z.external.help,
                            children: t("SUPPORT")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Item__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            href: _routes__WEBPACK_IMPORTED_MODULE_14__/* ["default"].external.howToBuy */ .Z.external.howToBuy,
                            children: t("HOW_TO_BUY")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Item__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Navbar_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            href: _routes__WEBPACK_IMPORTED_MODULE_14__/* ["default"].external.biopharma */ .Z.external.biopharma,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    name: "link-ext"
                                }),
                                t("GENEIOUS_BIOLOGICS")
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Navbar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                nav: "secondary",
                type: 1,
                inverted: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Item__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        secondary: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_smart_react_NextLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            Component: _insightfulscience_atomic_react_Navbar_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z,
                            href: _routes__WEBPACK_IMPORTED_MODULE_14__/* ["default"].myAccount */ .Z.myAccount,
                            className: "nav__item-link",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    name: "user-alt"
                                }),
                                " ",
                                isAuthorized ? t("MY_ACCOUNT") : t("SIGNIN")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Navbar_Item__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        secondary: true,
                        className: "secondary-nav__item-trial",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Link */ .Z.Link, {
                            href: _routes__WEBPACK_IMPORTED_MODULE_14__/* ["default"].freeTrial */ .Z.freeTrial,
                            size: "s",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    name: "arrow-to-bottom"
                                }),
                                " ",
                                t("FREE_TRIAL")
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
SiteHeaderFeature.propTypes = {
    isAuthorized: prop_types__WEBPACK_IMPORTED_MODULE_21__.bool
};


/***/ }),

/***/ 18036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ isTokenValid; },
/* harmony export */   "t": function() { return /* binding */ isNotExpired; }
/* harmony export */ });
/* harmony import */ var _insightfulscience_shared_utils_jwt_jwtPayload__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58644);

/** @type {(token: { exp: number }) => boolean} */ const isNotExpired = (token)=>token && token.exp * 1000 > Date.now();
/** @type {(token: string) => boolean} */ const isTokenValid = (token)=>Boolean(token) && (0,_insightfulscience_shared_utils_jwt_jwtPayload__WEBPACK_IMPORTED_MODULE_0__/* .jwtPayload */ .q1)(token) != null;


/***/ }),

/***/ 11969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _insightfulscience_smart_react_hocs_DiPageHoC__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44611);
/* harmony import */ var _status__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80220);


const useIsAuthorized = ()=>{
    const isAuthorized = (0,_insightfulscience_smart_react_hocs_DiPageHoC__WEBPACK_IMPORTED_MODULE_0__/* .useRun */ .Sr)(()=>(param)=>{
            let { storageService: { token , refreshToken  }  } = param;
            return (0,_status__WEBPACK_IMPORTED_MODULE_1__/* .areTokensValid */ .iJ)(token, refreshToken);
        });
    return isAuthorized();
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsAuthorized);


/***/ }),

/***/ 80220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QO": function() { return /* binding */ isAuthorized; },
/* harmony export */   "_j": function() { return /* binding */ isNotAuthorized; },
/* harmony export */   "iJ": function() { return /* binding */ areTokensValid; }
/* harmony export */ });
/* harmony import */ var _insightfulscience_shared_utils_validation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69340);
/* harmony import */ var _domain_token__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18036);


const areTokensValid = (token, refreshToken)=>(0,_domain_token__WEBPACK_IMPORTED_MODULE_1__/* .isTokenValid */ .D)(token.read()) && (0,_domain_token__WEBPACK_IMPORTED_MODULE_1__/* .isTokenValid */ .D)(refreshToken.read());
const isAuthorized = (context, param)=>{
    let { storageService: { token , refreshToken  }  } = param;
    return areTokensValid(token, refreshToken);
};
const isNotAuthorized = (0,_insightfulscience_shared_utils_validation__WEBPACK_IMPORTED_MODULE_0__/* .not */ .ff)(isAuthorized);


/***/ })

}]);